import React, { Component } from 'react';
import JurisLogoText from './JurisLogoText';

import { connect } from 'react-redux';

class JurisContact extends Component {

    render() {
        return (
            <section className="juris-contact dark-bg row">

                    <div className="col-xs-12">

                        <div className="container">

                            <div className="row juris-section-title xs-text-center">
                                <div className="col-xs-12 col-sm-5 col-md-3 text-center">

                                    <div className="title-container">
                                        <h2> {this.props.title} </h2>
                                    </div>

                                </div>

                                <div className="col-xs-12 col-sm-6 col-md-5">
                                    <p> {this.props.subtitle} </p>
                                </div>
                            </div>

                            <div className="row contact-details">

                                <div className="col-xs-12 col-sm-4 text-center contact-details-column">
                                    <JurisLogoText />
                                </div>
                                
                                <div className="col-xs-12 col-sm-4 text-center contact-details-column">
                                    <p> {this.props.addressLine1} </p>
                                    <p> {this.props.addressLine2} </p>
                                </div>

                                <div className="col-xs-12 col-sm-4 text-center contact-details-column">
                                    <p>
                                        { this.props.telephone } 
                                    </p>

                                    <p>
                                        { this.props.fax } 
                                    </p> 

                                </div>

                            </div>
                            
                        

                        </div>

                    
                    </div>

            </section>
        )
    }
}

const mapStateToProps = ({currentLocale, dictionaries}) => {
    return {
        title : dictionaries[currentLocale]["contact"]["title"],
        subtitle : dictionaries[currentLocale]["contact"]["subtitle"],
        addressLine1 : dictionaries[currentLocale]["contact"]["address"]["line1"],
        addressLine2 : dictionaries[currentLocale]["contact"]["address"]["line2"],
        
        telephone : dictionaries[currentLocale]["contact"]["telephone"],
        fax : dictionaries[currentLocale]["contact"]["fax"]
    }
}

export default connect(mapStateToProps)(JurisContact);


/** WEBPACK FOOTER **
 ** ./src/components/JurisContact.jsx
 **/